var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import axios from 'axios';
// @ts-ignore
import Message from 'element-ui/packages/message/index.js';
// @ts-ignore
import MessageBox from 'element-ui/packages/message-box/index.js';
import { removeAuth } from '@/utils/auth';
import qs from 'qs';
import { debounce } from 'throttle-debounce';
import router from '../router';
import store from '@/store';
import { StaticPaths } from '@/common/request/utils';
import { getStorage, getCookie } from '@lhb/cache';
/**
 * 检查dom是否忽略
 * @param {*} e
 */
var clearCacheEnterLogin = debounce(500, function () {
    // 已经在登录页面不清空
    var currentRoute = window.app.$route;
    if (currentRoute && currentRoute.name === 'login') {
        return;
    }
    removeAuth().then(function () {
        console.log('removeAuth');
        // TODO 暂时注释
        // location.reload(); // 为了重新实例化vue-router对象 避免bug
    }).catch(function () {
        // location.reload();
    });
});
var errorMessage = debounce(500, function (message, type) {
    if (type === void 0) { type = 'error'; }
    console.log(message);
    Message({
        message: message,
        duration: 1500,
        type: type
    });
});
var confirmMessage = debounce(1000, function (message) {
    MessageBox.confirm(message, '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showClose: false,
        type: 'warning'
    }).then(function () {
        if ((window.app.$route && window.app.$route.name !== 'login') || !window.app.$route) {
            clearCacheEnterLogin();
        }
        else {
            removeAuth();
        }
    }).catch(function () {
    });
});
// 创建axios实例
var service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 600000 // 请求超时时间
});
var getHeader = function () {
    var getTokenApi = getStorage('getTokenApi');
    var newPmsToken = getCookie('newPmsToken');
    var adminToken = axios.defaults.headers['Admin-Token'];
    var getCookieToken = newPmsToken || adminToken;
    if (process.env.NODE_ENV !== 'development') { // 开发环境屏蔽
        if (getCookieToken === '[object Object]') { // 如果是对象，就上报
            // 主动send事件
            window.LHBbigdata.send({
                event_id: 'location_pms_pc_cookie_monitoring_token',
                msg: {
                    newPmsToken: newPmsToken,
                    adminToken: adminToken
                },
            });
        }
    }
    var res = {
        clientKey: 1000010,
    };
    if (getCookieToken) {
        res['token'] = getCookieToken;
        res['originToken'] = JSON.stringify(getCookieToken);
    }
    if (getTokenApi) {
        res['tokenApi'] = getTokenApi;
    }
    return res;
};
service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
;
// request拦截器
service.interceptors.request.use(function (config) {
    config.headers = __assign(__assign({}, config.headers), getHeader());
    var flag = config.headers['Content-Type'] && config.headers['Content-Type'].indexOf('application/json') !== -1;
    if (!flag) {
        var mult = config.headers['Content-Type'] && config.headers['Content-Type'].indexOf('multipart/form-data') !== -1;
        if (!mult) {
            config.data = qs.stringify(config.data);
        }
    }
    else {
        if (config.data === undefined || config.data === null) {
            // 不传参的情况下 json类型的提交数据，校准为 空对象
            config.data = {};
        }
    }
    var validUrl = config.url.toLowerCase();
    if (!validUrl.includes('admin') &&
        !validUrl.includes('financeauth') &&
        !validUrl.includes('queryallemployeelist') &&
        !validUrl.includes('querytreelist')) {
        config.cancelToken = new axios.CancelToken(function (cancel) {
            store.commit('SET_CANCELTOKENARR', { cancelToken: cancel });
        });
    }
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});
// response 拦截器
service.interceptors.response.use(function (response) {
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    var res = response.data;
    if (response.status === 200 && response.config.responseType === 'blob') { // 文件类型特殊处理
        if (response.headers['content-disposition'] || (response.headers['content-type'] && response.headers['content-type'].indexOf('application/pdf') !== -1)) {
            return response;
        }
        else if (response.data) {
            var resultBlob = new Blob([response.data], { type: 'application/json' });
            var fr = new FileReader();
            fr.onload = function () {
                // @ts-ignore
                var result = JSON.parse(this.result);
                // 附件下载反馈的302 忽略
                if (result.msg && result.code !== 302) {
                    errorMessage(result.msg, result.code === 1 ? 'success' : 'error');
                }
            };
            fr.readAsText(resultBlob);
        }
    }
    else if (res.code !== 0 && res.code !== undefined) {
        // 302	登录已失效
        if (res.code === 302) {
            if (res.data && res.data.extra === 1) {
                confirmMessage("\u60A8\u7684\u8D26\u53F7" + res.data.extraTime + "\u5728\u522B\u5904\u767B\u5F55\u3002\u5982\u975E\u672C\u4EBA\u64CD\u4F5C\uFF0C\u5219\u5BC6\u7801\u53EF\u80FD\u5DF2\u6CC4\u6F0F\uFF0C\u5EFA\u8BAE\u4FEE\u6539\u5BC6\u7801");
            }
            else {
                clearCacheEnterLogin();
            }
        }
        else if (res.code === 1005) {
            removeAuth().then(function () {
                window.accessLogin = true;
                setTimeout(function () {
                    router.push("/login?type=perfect&mobile=" + res.data + "&time=" + new Date().getTime());
                }, 500);
            }).catch(function () { });
        }
        else if (res.code === 1007) { // 该企业没有该用户
            // 忽略Cookies 读取
            window.sessionStorage.wkIgnoreCookies = true;
            router.push('/login');
        }
        else if (res.code === 2120) { // 线索转客户 2120客户已存在，但联系人不存在
            return res;
        }
        else if (res.code === 1033) { // 用户未注册
            return res;
        }
        else {
            if (res.msg) {
                errorMessage(res.msg);
            }
        }
        return Promise.reject(res);
    }
    else {
        return res;
    }
}, function (error) {
    var response = error.response;
    if (!axios.isCancel(error)) { // 取消请求的情况下，终端Promise调用链
        if (error.response) {
            if (response.status === 401) {
                if (StaticPaths.indexOf(router.currentRoute.path) < 0 && !response.config.url.includes('qiniup.com')) {
                    return window.$_EventLib.dispatch('LOGOUT', '登录已失效，请重新登录');
                }
            }
            else if (response.status === 500) {
                errorMessage('网络错误，请检查您的网络');
            }
            else if (response.data && response.data.msg) {
                errorMessage(response.data.msg);
            }
            else if (response.data && response.data.errMsg) {
                errorMessage(response.data.errMsg);
            }
        }
        return Promise.reject(error);
    }
});
export default service;
